import React from 'react';
import { colors } from '@alixpartners/ui-components';

const OthersColorIcon = () => (
  <svg x="0" y="0" width="16" height="16">
    <defs>
      <pattern
        id="diagonalHatch"
        patternUnits="userSpaceOnUse"
        width="5"
        height="5"
      >
        <path
          d="M -1 1 l 2 -2 M 0 5 l 5 -5 M 4 6 l 2 -2"
          stroke={colors.grey3}
          strokeWidth="2"
        />
      </pattern>
    </defs>
    <rect x="1" y="1" width="16" height="16" fill="url(#diagonalHatch)" />
  </svg>
);

export default OthersColorIcon;
